import React from 'react';
import { Helmet } from 'react-helmet';
export var ResponsiveIframeScript = function ResponsiveIframeScript() {
  return /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    src: "https://content.wirkaufendeinauto.de/static/car_images/iframe-resizer-content.min.js"
  }));
};